import { render, staticRenderFns } from "./PricePlans.vue?vue&type=template&id=14a4b906&scoped=true"
import script from "./PricePlans.vue?vue&type=script&lang=ts"
export * from "./PricePlans.vue?vue&type=script&lang=ts"
import style0 from "./PricePlans.vue?vue&type=style&index=0&id=14a4b906&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a4b906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a4b906')) {
      api.createRecord('14a4b906', component.options)
    } else {
      api.reload('14a4b906', component.options)
    }
    module.hot.accept("./PricePlans.vue?vue&type=template&id=14a4b906&scoped=true", function () {
      api.rerender('14a4b906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/prices/PricePlans.vue"
export default component.exports